import React from 'react';
import DashboardSidebar from './DashboardSidebar';
import { Outlet } from 'react-router-dom';

const Layout = () => (
  <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
    <DashboardSidebar />
    <main style={{ flexGrow: 1, padding: '1rem', overflowY: 'auto' }}>
      <Outlet />
    </main>
  </div>
);

export default Layout;
